import { render, staticRenderFns } from "./divide-dialog.vue?vue&type=template&id=71ff1fa2&class=divide-dialog&"
import script from "./divide-dialog.vue?vue&type=script&lang=js&"
export * from "./divide-dialog.vue?vue&type=script&lang=js&"
import style0 from "./divide-dialog.vue?vue&type=style&index=0&id=71ff1fa2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports